import { FC } from "react";
import { IconButton } from "@mui/material";
import SettingsIcon from "@/assets/icons/side-menu/settings-Icon";

interface SettingsButtonProps {
  variant?: "icon" | "text";
}

const SettingsButton: FC<SettingsButtonProps> = ({ variant = "icon" }) => {
  if (variant === "text") {
    return <span>Settings</span>;
  }

  return (
    <IconButton
      sx={{
        color: "white",
        width: 40,
        height: 40,
        borderRadius: "50%",
      }}
    >
      <SettingsIcon />
    </IconButton>
  );
};

export default SettingsButton;
